const DEVICON_BASE = 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons';
const SIMPLE_ICONS_COLORED = (slug, color) => `https://cdn.simpleicons.org/${slug}/${color}`;

export const techIcons = {
  'Next.js': `${DEVICON_BASE}/nextjs/nextjs-original.svg`,
  'FastAPI': `${DEVICON_BASE}/fastapi/fastapi-original.svg`,
  'MongoDB': `${DEVICON_BASE}/mongodb/mongodb-original.svg`,
  'Docker': `${DEVICON_BASE}/docker/docker-original.svg`,
  'React': `${DEVICON_BASE}/react/react-original.svg`,
  'React (Vite)': `${DEVICON_BASE}/react/react-original.svg`,
  'Sass': `${DEVICON_BASE}/sass/sass-original.svg`,
  'Tailwind CSS': `${DEVICON_BASE}/tailwindcss/tailwindcss-original.svg`,
  'Vite': `${DEVICON_BASE}/vitejs/vitejs-original.svg`,
  'Express.js': `${DEVICON_BASE}/express/express-original.svg`,
  'Prisma ORM': `${DEVICON_BASE}/prisma/prisma-original.svg`,
  'PostgreSQL': `${DEVICON_BASE}/postgresql/postgresql-original.svg`,
  'PostgreSQL (Supabase)': `${DEVICON_BASE}/postgresql/postgresql-original.svg`,
  'Python': `${DEVICON_BASE}/python/python-original.svg`,
  'TypeScript': `${DEVICON_BASE}/typescript/typescript-original.svg`,
  'HTML': `${DEVICON_BASE}/html5/html5-original.svg`,
  'CSS': `${DEVICON_BASE}/css3/css3-original.svg`,
  'Material-UI': `${DEVICON_BASE}/materialui/materialui-original.svg`,
  'Vercel': `${DEVICON_BASE}/vercel/vercel-original.svg`,
  'Google Cloud': `${DEVICON_BASE}/googlecloud/googlecloud-original.svg`,
  'React Router': SIMPLE_ICONS_COLORED('reactrouter', 'CA4245'),
  'JWT': 'https://jwt.io/img/logo-asset/logo-vertical.svg',
  'Axios': SIMPLE_ICONS_COLORED('axios', '5A29E4'),
  'Render': SIMPLE_ICONS_COLORED('render', '46E3B7'),
  'OpenCV': SIMPLE_ICONS_COLORED('opencv', '5C3EE8'),
  'MediaPipe': SIMPLE_ICONS_COLORED('mediapipe', '4285F4'),
  'Discord API': SIMPLE_ICONS_COLORED('discord', '5865F2'),
  'Railway': SIMPLE_ICONS_COLORED('railway', 'F2622E'),
  'Google Gemini': SIMPLE_ICONS_COLORED('googlegemini', '4285F4'),
  'Gemini 3 Flash': SIMPLE_ICONS_COLORED('googlegemini', '4285F4'),
  'Meta Llama': SIMPLE_ICONS_COLORED('meta', '0081FB'),
  'Pandas': SIMPLE_ICONS_COLORED('pandas', '150458'),
  'scikit-learn': SIMPLE_ICONS_COLORED('scikitlearn', 'F7931E'),
  'DigitalOcean': SIMPLE_ICONS_COLORED('digitalocean', '0080FF'),
  'Cloud Run': `${DEVICON_BASE}/googlecloud/googlecloud-original.svg`,
  'pgvector': `${DEVICON_BASE}/postgresql/postgresql-original.svg`,
  'SQLModel': `${DEVICON_BASE}/python/python-original.svg`,
  'AsyncIO': `${DEVICON_BASE}/python/python-original.svg`,
};
